 import { Environment } from '@abp/ng.core';

const baseUrl = 'https://seedlingsupply-reception-dev.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://seedlingsupply-reception-backend-dev.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'SeedlingSupplyReception_App',
  responseType: 'code',
  scope: 'offline_access SeedlingSupplyReception',
  requireHttps: true,
  impersonation: {
    tenantImpersonation: true,
    userImpersonation: true,
  }
};

export const environment = {
  name: 'development',
  production: false,
  application: {
    baseUrl,
    name: 'SeedlingSupplyReception',
    logoUrl: 'assets/images/logo/logo-light.svg',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://seedlingsupply-reception-backend-dev.upmuruguay.net',
      rootNamespace: 'Upm.SeedlingSupplyReception',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  appVersion: '0.0.1',
  grafana: {
    isEnabled: false,
    url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/a6d2c7f0bac6ef20f2e7876f7289ed2a',
  }
} as Environment;
